export enum BdDunningActionExecutionType {
    AUTOMATIC,
    MANUAL
}
